module.exports = __webpack_public_path__ + "img/57.bd552505.webp";